import { ColorProps } from 'types';

// ==============================|| THEME 3 COLORS ||============================== //

const theme3: ColorProps = {
  // paper & background
  paper: '#ffffff',

  // primary
  primaryLight: '#e3ebeb',
  primaryMain: '#16595a',
  primaryDark: '#135152',
  primary200: '#8bacad',
  primary800: '#0c3e3f',

  // secondary
  secondaryLight: '#f8f0e5',
  secondaryMain: '#c77e23',
  secondaryDark: '#c1761f',
  secondary200: '#e3bf91',
  secondary800: '#b36115',

  // success
  successLight: '#b9f6ca',
  success200: '#69f0ae',
  successMain: '#00e676',
  successDark: '#00c853',

  // error
  errorLight: '#ef9a9a',
  errorMain: '#f44336',
  errorDark: '#c62828',

  // orange
  orangeLight: '#fbe9e7',
  orangeMain: '#ffab91',
  orangeDark: '#d84315',

  // warning
  warningLight: '#fff8e1',
  warningMain: '#ffe57f',
  warningDark: '#ffc107',

  // grey
  grey50: '#f8fafc',
  grey100: '#eef2f6',
  grey200: '#e3e8ef',
  grey300: '#cdd5df',
  grey500: '#697586',
  grey600: '#4b5565',
  grey700: '#364152',
  grey900: '#121926',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkPaper: '#0a181f',
  darkBackground: '#010606',

  // dark 800 & 900
  darkLevel1: '#02131d',
  darkLevel2: '#010f17',

  // text variants
  darkTextTitle: '#ffffff',
  darkTextPrimary: '#ffffff',
  darkTextSecondary: '#8492c4',

  // primary dark
  darkPrimaryLight: '#eceff1',
  darkPrimaryMain: '#1f7778',
  darkPrimaryDark: '#1b6f70',
  darkPrimary200: '#8fbbbc',
  darkPrimary800: '#125a5b',

  // secondary dark
  darkSecondaryLight: '#f8f0e5',
  darkSecondaryMain: '#c77e23',
  darkSecondaryDark: '#c1761f',
  darkSecondary200: '#e3bf91',
  darkSecondary800: '#b36115'
};

export default theme3;
